// extracted by mini-css-extract-plugin
export default {"statusDescription":"StatusDescription_statusDescription__mUPgF"};